import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';

export const requestDiscountAuthorization = async (branchId, cashRegisterId, payload) => {
  try {
    const token = getToken();
    const response = await axios.post(
      `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/discounts/request`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    const err = new Error(error.response?.data?.message || 'Error solicitando autorizacion de descuento');
    err.attemptsRemaining = error.response?.data?.attemptsRemaining;
    throw err;
  }
};

export const validateDiscountAuthorization = async (branchId, cashRegisterId, payload) => {
  try {
    const token = getToken();
    const response = await axios.post(
      `${API_URL}/branch/${branchId}/cash-registers/${cashRegisterId}/discounts/validate`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    const err = new Error(error.response?.data?.message || 'Error validando autorizacion de descuento');
    err.attemptsRemaining = error.response?.data?.attemptsRemaining;
    throw err;
  }
};
